export const API_BASE = window.location.hostname.includes('localhost')
  ? 'http://localhost:8080'
  : 'https://morenoflix.herokuapp.com';
